import { userFeature } from '@state';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MsisdnRadioButtonListComponent } from '@shared/components/msisdn-radio-button-list/msisdn-radio-button-list.component';
import { MsisdnPipe, PhoneNumberPipe, TranslatePipe } from '@core/pipes';
import { ClickToCopyDirective } from '@core/directives';
import { Store } from '@ngrx/store';
import { SvgComponent } from '../svg/svg.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sc-msisdn-preview',
  imports: [
    SvgComponent,
    MsisdnRadioButtonListComponent,
    PhoneNumberPipe,
    ClickToCopyDirective,
    MsisdnPipe,
    TranslatePipe,
    AsyncPipe,
  ],
  templateUrl: './msisdn-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MsisdnPreviewComponent {
  currentMsisdn = this.store.selectSignal(userFeature.selectSelectedMsisdn);
  isOpen = signal<boolean>(false);
  isLimited = this.store.selectSignal(userFeature.selectIsMsisdnLimited);

  constructor(private readonly store: Store) {}
}
